import { Injectable, inject } from "@angular/core";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";
import { MultiSelectModel, Option, VisibilityParams } from "./filter-types";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: "root",
})
export class TagsFilterGeneratorService {
    private readonly translateService = inject(TranslateService);
    constructor() {}

    generateModel(selection: Option[], isiFirmTaxDashboard: boolean) {
        const options: Option[] = [
            {
                text: "FiltersSidebar.Options.Tags.VIP",
                value: "VIP",
            },
            {
                text: "FiltersSidebar.Options.Tags.NotVIP",
                value: "NotVIP",
            },
            {
                text: "FiltersSidebar.Options.Tags.DUP",
                value: "DUP",
                isVisible: (params: VisibilityParams) => !params.isiFirmTaxDashboard,
            },
        ].sort((a, b) => this.translateService.instant(a.text.toString()).localeCompare(this.translateService.instant(b.text.toString())));

        const applicableOptions = options.filter((option) =>
            option.isVisible ? (typeof option.isVisible === "boolean" ? option.isVisible : option.isVisible({ isiFirmTaxDashboard })) : true,
        );
        return {
            label: "FiltersSidebar.Labels.Tags",
            allOptions: options,
            applicableOptions,
            selection,
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    generateFilter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        } else {
            const applicableChecks = selectedValues.reduce((applicable, value) => {
                if (value === "VIP") {
                    applicable.push((card: TaxprepT1Card) => card.isVIP);
                } else if (value === "NotVIP") {
                    applicable.push((card: TaxprepT1Card) => !card.isVIP);
                } else if (value === "DUP") {
                    applicable.push((card: TaxprepT1Card) => card.originalId);
                }
                return applicable;
            }, []);

            return (card: TaxprepT1Card) => {
                return applicableChecks.some((check) => check(card));
            };
        }
    }
}
